var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-chip.ts
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { ChemistryLitElement } from "../../chemistry-lit-element";
import { xComponents } from "../x-components";
var ElementsChip = class extends ChemistryLitElement {
  styles() {
    return {
      ":host": {
        display: "block",
        borderRadius: "50px",
        background: this.colors.accent,
        color: this.colors.on.accent,
        padding: `${this.spacing.xs} ${this.spacing.sm}`,
        whiteSpace: "nowrap",
        "@media print": {
          padding: `${this.spacing.xxs} ${this.spacing.xs}`,
          background: "transparent",
          color: this.colors.on.white,
          "x-text": { fontWeight: "bold" }
        }
      },
      ":host([tone=subtle])": { color: this.colors.on.neutral_700, background: this.colors.neutral_700 },
      ":host([tone=success])": { color: this.colors.on.tone.success, background: this.colors.tone.success },
      ":host([tone=warning])": { color: this.colors.on.tone.warning, background: this.colors.tone.warning },
      ":host([tone=error])": { color: this.colors.on.tone.error, background: this.colors.tone.error }
    };
  }
  render() {
    return xComponents(html` <x-text color-unset> <slot></slot> </x-text> `);
  }
};
ElementsChip = __decorateClass([
  customElement("x-chip")
], ElementsChip);
export {
  ElementsChip
};
